import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

class FormattedQueriesModal extends Component {
    componentDidMount() {
        this.closeAction();
    }

    closeFormattedQueriesModal = async () => {
        $('#formattedQueriesModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#formattedQueriesModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const { formattedInfo = {}, selectFormattedQueries, formattedMap } = this.props;
        const { Name = '', Field, needFormattedQuery = false } = formattedInfo;
        const data = needFormattedQuery ? formattedInfo?.formattedMap?.[Field] ?? [] : formattedMap?.[Field] ?? [];
        const headers = data?.length
            ? Object.keys(data?.[0])?.map(key => ({
                title: key?.replace(/([A-Z])/g, ' $1')?.trim()
            }))
            : [];

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" role="dialog" id="formattedQueriesModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">{`Información del campo "${Name}"`}</h4>
                                <button type="button" className="close" onClick={this.closeFormattedQueriesModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{ marginBottom: 0, height: 570, maxHeight: 570 }}>
                                                    <tbody>
                                                        <DataTablesCreate
                                                            headers={headers}
                                                            data={data}
                                                            view={"formattedQueries"}
                                                            action={selectFormattedQueries}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeFormattedQueriesModal}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormattedQueriesModal;